import React from 'react';

import PropTypes from 'prop-types';

import Helmet from 'wanderu-component-helmet';

import logo from 'wanderu-assets/images/logo.png';

function HomePageMeta(props) {
    const {
        defaultLocale,
        locale,
        ...otherProps
    } = props;

    const localizedHomepageUrl = locale === defaultLocale
        ? 'https://www.wanderu.com/'
        : `https://www.wanderu.com/${locale}/`;

    const structuredData = [
        {
            '@context': 'http://schema.org',
            '@type': 'Organization',
            name: 'Wanderu',
            url: localizedHomepageUrl,
            logo: logo,
            sameAs: [
                'https://www.facebook.com/gowanderu',
                'https://twitter.com/gowanderu',
                'http://instagram.com/wanderu',
                'https://plus.google.com/+Wanderu',
                'https://www.linkedin.com/company/wanderu-inc',
            ],
        },
        {
            '@context': 'http://schema.org',
            '@type': 'Website',
            name: 'Wanderu',
            url: localizedHomepageUrl,
        },
    ];

    return (
        <Helmet
            {...otherProps}
            structuredData={structuredData}
        />
    );
}

HomePageMeta.propTypes = {
    defaultLocale: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
};

export default HomePageMeta;
